import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeUnderscorePipe'
})
export class RemoveUnderscorePipePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value){
      return value.replace(/_/g, " ");
    }
  }

}